import {Color} from "@/lib/styles";
import {useQuery} from "@tanstack/react-query";
import {ServerInfo} from "@/lib/types";
import {dataRetryPolicy, fetchBackend} from "@/lib/backend";
import Header from "@/lib/components/Header";
import Message from "@/lib/components/Message";
import {ActivityIndicator, Platform} from "react-native";
import ErrorMessage from "@/lib/components/ErrorMessage";
import * as Application from 'expo-application';
import Page from "@/lib/pages/Page";
import {useState} from "react";
import {BASE_URL} from "@/lib/constants";

export default function DebugScreen() {
    const [latency, setLatency] = useState<number | null>(null);
    const {data, isLoading, error} = useQuery<ServerInfo>({
        queryKey: ['server'],
        queryFn: async () => {
            const then = new Date();
            const data = await fetchBackend<ServerInfo>(`/server`, "GET");
            const now = new Date();
            setLatency(now.getTime() - then.getTime());
            return data;
        },
        retry: dataRetryPolicy,
    });

    const friendlyName = (() => {
        if (Platform.OS === "ios") {
            return `${Platform.constants.systemName} ${Platform.constants.osVersion}`;
        } else if (Platform.OS === "android") {
            return `Android ${Platform.constants.Release} ( API ${Platform.Version.toString()} )`;
        } else {
            return "Web"
        }
    })();

    return (
        <Page scrollable={true}>
            <Header title={"System"}/>
            <Message text={friendlyName}/>

            {Platform.OS !== "web" &&
                <>
                    <Header title={"App"}/>
                    <Message text={`${Application.nativeApplicationVersion} ( ${Application.nativeBuildVersion} )`}/>
            {Platform.constants.isTesting && <Message text={"Utviklerversjon"}/>}
                </>}

            <Header title={"Backend"}/>

            <Message text={BASE_URL}/>
            <Header title={"Server"}/>
            {data && <Message text={data.version}/>}
            {isLoading && <ActivityIndicator color={Color.PrimaryText} size={"small"}/>}
            {error && <ErrorMessage error={error}/>}
            {latency &&
                <>
                    <Header title={"Responstid"}/>
                    <Message text={`${latency} ms`}/>
                </>}
        </Page>
    )
}